export default __webpack_public_path__ + "3a9de5aabd2ac1c45daa1951e6401cd5.svg";